import { getLandingPath } from "@fitness-app/data-models/entities/LandingPage";

export const getEcommerceOrigin = () => {
  const domain = import.meta.env.VITE_ECOMMERCE_DOMAIN?.trim().replace(/\/+$/, "");
  const isLocalAdmin =
    typeof window !== "undefined" &&
    (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");

  if (isLocalAdmin) {
    return import.meta.env.VITE_LOCAL_ECOMMERCE_ORIGIN ?? "http://localhost:3001";
  }

  if (!domain) {
    return "";
  }

  if (/^https?:\/\//i.test(domain)) {
    return domain;
  }

  const protocol = domain.startsWith("localhost") || domain.startsWith("127.0.0.1") ? "http" : "https";
  return `${protocol}://${domain}`;
};

export const getPublicUrl = (slug: string) => `${getEcommerceOrigin()}${getLandingPath(slug)}`;

export const getTemplatePreviewUrl = (key: string) => `${getEcommerceOrigin()}/landing-template-preview/${key}`;
